// @flow
import type {OrderState} from './order';

export const INPUT_TYPE = Object.freeze({
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  CHECKLIST: 'CHECKLIST',
  DATE_PICKER: 'DATE_PICKER',
});

export const MAP_INPUT_TYPE_NAME = {
  TEXT: 'Texto',
  NUMBER: 'Número',
  CHECKLIST: 'Multi Opción',
  DATE_PICKER: 'Calendario',
};

export type InputType = $Keys<typeof INPUT_TYPE>;

export type CheckoutInput = {
  id: string,
  enabled: boolean,
  required: boolean,
  name: string,
  number: number,
  schema?: {[key: string]: any},
  description?: string,
  inputType: InputType,
};
export type SalesProcessInformation = CheckoutInput[];

export type OrderStateMessageConfig = {
  enabled: Boolean,
  message: string,
  orderState: OrderState,
  type: 'order-message',
};
